<template>
	<v-container fluid class="pt-3 mb-1">
		<v-snackbar v-model="prDeletedNotif" top>
			Performance Review Deleted
			<v-btn color="pink" flat @click="prDeletedNotif = false">
				Close
			</v-btn>
		</v-snackbar>

		<v-layout v-if="showFilterBar" row wrap class="mb-1">
			<v-flex xl3 lg4 md6 sm6 xs12 class="pr-3">	
				<v-text-field v-debounce:300ms="updateSearch" ref="focusAfterTagSelector" append-icon="search" label="Search Employees" autofocus="" background-color="#fff"></v-text-field>
			</v-flex>
			<v-flex xl3 lg4 md6 sm6 xs12 class="pr-3">
				<tag-selector :options="tagList"
							:selectedOptions="selectedTags"
							:isMatchAll="matchAllTags"
							placeholder="Enter Tag"
							@on-selected-tags-change="updateSelectedTags"
							@on-match-all-tags-change="updateMatchAllTags"
							@on-leave="onLeaveTagSelector"></tag-selector>
			</v-flex>
		</v-layout>

		<v-layout row wrap>
			<v-flex lg12>
				<v-card class="mb-4">
					<v-toolbar flat dense cad>
						<v-toolbar-title class="subheading">Pending Reviews</v-toolbar-title>
						<v-spacer></v-spacer>
					</v-toolbar>
					<v-divider></v-divider>

					<v-data-table disable-initial-sort :headers="headers" :items="filteredPending" :loading="performanceReviews_loading" hide-actions class="elevation-1">
						<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>

						<template slot="items" slot-scope="props">
							<tr :active="props.item.isLoggedInEmployee || props.item.isLoggedInReviewer" :class="{ discussion: props.item.status==='Discussion' }">
								<td class="text-xs-left">{{ props.item.name }}</td>
								<td class="text-xs-left">	
									<router-link :to="{ name: 'employee', params: { id: props.item.employeeId } }"><span :class="{ highlight: props.item.isLoggedInEmployee }">{{ props.item.employee }}</span></router-link>
								</td>
								<td class="text-xs-left">{{ props.item.positionTitle }}</td>
								<td class="text-xs-left">
									<router-link :to="{ name: 'employee', params: { id: props.item.reviewerId } }"><span :class="{ highlight: props.item.isLoggedInReviewer }">{{ props.item.reviewer }}</span></router-link>							
								</td>
								<td class="text-xs-left">			
									<v-tooltip bottom v-if="isInPast(props.item.scheduledDate)">
										<div slot="activator">
											<v-icon color="#f44336" small >mdi-alert-circle-outline</v-icon>
											{{ props.item.scheduledDate | formatDate() }}
										</div>									
										<span>Due <AppDate :date="props.item.scheduledDate" /></span>
									</v-tooltip>
									<span v-else>{{ props.item.scheduledDate | formatDate() }}</span>
								</td>
								<td class="text-xs-left" :style="{'color': props.item.status === 'Discussion' ? '#388E3C' : props.item.status === 'InProgress' ? '#fb8c00' : ''}">{{ getUserFriendlyStatus(props.item.status) }}</td>
								<td class="text-xs-right px-0" style="width: 1px;">
									<v-btn small @click="view(props.item)">View</v-btn>
								</td>
								<td class="justify-center pl-0 pr-2" style="width: 1px;">
									<v-icon v-if="loggedInEmployee != null && loggedInEmployee.isAdmin" small @click="deletePerformanceReview(props.item)">
										delete
									</v-icon>
								</td>
							</tr>
						</template>
					</v-data-table>
				</v-card>
			</v-flex>

			<v-flex lg12>
				<v-card class="mb-4">
					<v-toolbar flat dense class="success" dark>
						<v-toolbar-title class="subheading">Completed Reviews</v-toolbar-title>
						<v-spacer></v-spacer>
							
				
					</v-toolbar>
					<v-divider></v-divider>

					<v-footer color="" app height="55">
						<v-spacer></v-spacer>
						<footer-add-btn @click="onAddClick">
							New Performance Review
						</footer-add-btn>
					</v-footer>

					<v-card-text>
						<v-flex md3>
							<v-select v-model="completedListFilter" :items="completedListFilterOptions" item-text="text" item-value="value" label="Period" required></v-select>
						</v-flex>
					</v-card-text>


					<v-data-table disable-initial-sort :headers="headers" :items="filteredComplete" :loading="performanceReviews_loading" hide-actions class="elevation-1">
						<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>

						<template slot="items" slot-scope="props">
							<tr>
								<td class="text-xs-left">{{ props.item.name }}</td>
								<td class="text-xs-left">
									<router-link :to="{ name: 'employee', params: { id: props.item.employeeId } }">{{ props.item.employee }}</router-link>
								</td>
								<td class="text-xs-left">{{ props.item.positionTitle }}</td>
								<td class="text-xs-left">
									<router-link :to="{ name: 'employee', params: { id: props.item.reviewerId } }">{{ props.item.reviewer }}</router-link>
								</td>
								<td class="text-xs-left">{{ props.item.scheduledDate | formatDate() }}</td>
								<td class="text-xs-left" :style="{'color': props.item.status === 'Complete' ? '#388E3C' : ''}">Completed <AppDate :date="props.item.completedDateUtc" /></td>
								<td class="text-xs-right px-0"  style="width: 1px;">
									<v-btn small @click="view(props.item)">View</v-btn>
								</td>
								<td class="justify-center pl-0 pr-2" style="width: 1px;">
									<v-icon v-if="loggedInEmployee != null && loggedInEmployee.isAdmin" small @click="deletePerformanceReview(props.item)">
										delete
									</v-icon>
								</td>
							</tr>
						</template>
					</v-data-table>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
	import moment from 'moment';
	import { mapState, mapGetters } from 'vuex';
	import performanceReviewStatusMixin from '@/mixins/performanceReviewStatusMixin';
	import TagSelector from '@/components/tags/TagSelector';

	export default {
		components: {
			TagSelector
		},
		data() {
			return {
				prDeletedNotif: false,
				headers: [
					{ text: 'Type', value: 'name' },
					{ text: 'Employee', value: 'employee' },
					{ text: 'Job Title', value: 'positionTitle' },
					{ text: 'Reviewer', value: 'reviewer' },
					{ text: 'Scheduled Date', value: 'scheduledDateUTC', sortable: false },
					{ text: 'Status', value: 'status' },
					{ text: '', value: 'actions', sortable: false }
				],
				completedListFilter: 3,
				completedListFilterOptions: [
					{ value: 0, text: 'This month' },
					{ value: 1, text: 'Last 3 months' },
					{ value: 2, text: 'Last 6 months' },
					{ value: 3, text: new Date().getUTCFullYear() },
					{ value: 4, text: 'All time' },
				],
				radioGroup: 1,
				search: '',
				selectedTags: [],
				matchAllTags: false
			};
		},
		mixins: [performanceReviewStatusMixin],
		computed: {
			...mapGetters({
				loggedInEmployee: 'loggedInEmployee',
				pending: 'performanceReviews/performanceReviewsPendingList',
				completed: 'performanceReviews/performanceReviewsCompletedList',
				tagList: 'tags/employeeTagList',
				hasUnderlingsOrAdmin: 'hasUnderlingsOrAdmin'
			}),
			...mapState({
				performanceReviews_loading: state => state.performanceReviews.performanceReviews_loading
			}),
			filteredEmployeeIds() {
				const filterOptions = {
					search: this.search,
					tags: this.selectedTags,
					matchAllTags: this.matchAllTags
				};
				return this.$_getFilteredEmployeeIds(this.loggedInEmployee, filterOptions);
			},
			filteredPending() {
				return this.pending.filter(x => this.filteredEmployeeIds.includes(x.employeeId) || this.filteredEmployeeIds.includes(x.reviewerId));
			},
			filteredComplete() {
				let filtered = this.completed.filter(x => this.filteredEmployeeIds.includes(x.employeeId) || this.filteredEmployeeIds.includes(x.reviewerId));

				return filtered.filter(x => {
					switch(this.completedListFilter) {
						case 0:
							return x.scheduledDate > moment() || (moment(x.scheduledDate).year() === new Date().getUTCFullYear() && moment(x.scheduledDate).month() === new Date().getUTCMonth());
						case 1: 
							return x.scheduledDate > moment() || moment().diff(x.scheduledDate, 'months') <= 3;
						case 2: 
							return x.scheduledDate > moment() || moment().diff(x.scheduledDate, 'months') <= 6;
						case 3: 
							return x.scheduledDate > moment() || moment(x.scheduledDate).year() === new Date().getUTCFullYear();
						case 4: 
							return true;
						default: 
							return true;
					}
				});
			},
			showFilterBar() {
				return this.hasUnderlingsOrAdmin;
			},
		},
		methods: {
			onAddClick() {
				this.$router.push('/pr/create/');
			},
			edit(item) {
				this.$router.push(`/pr/${item.id}/edit/`);
			},
			deletePerformanceReview(item) {
				confirm('Are you sure you want to delete this Performance Review?') &&
					this.$store.dispatch('performanceReviews/delete', item).then(
						response => {
							this.prDeletedNotif = true;
						},
						error => {
							console.error('Error deleting performance review');
						}
					);
			},
			view(item) {
				this.$router.push(`/pr/${item.id}/`);
			},
			isInPast(dateUtc) {
				return moment.utc(dateUtc).isBefore(moment.utc());
			},
			updateSelectedTags(newSelectedTags) {
				this.selectedTags = newSelectedTags;
			},
			updateMatchAllTags(newMatchAll) {
				this.matchAllTags = newMatchAll;
			},
			onLeaveTagSelector() {
				this.$refs.focusAfterTagSelector.focus();
			},
			updateSearch(val) {
				this.search = val;
			}
		},
		created() {
			this.$store.dispatch('setPageTitle', 'Performance Reviews');
		}
	};
</script>

<style scoped>
	.highlight {
		/* color: #1565c0; */
		/* font-weight: 600; */
	}
	/* .discussion td:first-child {
		border-left: solid 10px #9E9E9E;
	} */
</style>

<style lang="scss"> 
 @import '@/styles/_colors.scss';

	.pr-overdue {
		color: $red;
	}
</style>